import React, { useState } from "react";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { addPost } from "../../actions/postActions";
import { Grid } from "@material-ui/core";
import { randomTopics } from "./../../constants/randomTopics";

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: 20,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
    },
  },
  textField: {
    width: "100%",
  },

  button: {
    alignSelf: "flex-end",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: "#fff",
      border: `2px solid ${theme.palette.primary.main}`,
    },
    "&:disabled": {
      backgroundColor: "rgba(0,0,0,0.08)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(1),
    },
  },

  buttonGroupRight: {
    display: "flex",
    gap: theme.spacing(2.5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  buttonGroup: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
}));

const AddPost = ({ data }) => {
  const [text, setText] = useState("");
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const postData = {
      text,
    };

    dispatch(addPost(postData));
    setText("");
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const username = capitalizeFirstLetter(data.login);

  const generateRandomTopic = () => {
    const randomIndex = Math.floor(Math.random() * randomTopics.length);
    setText(randomTopics[randomIndex]);
  };

  return (
    <Grid className={`font-Montserrat mb-2 ${classes.background}`}>
      <section>
        <h1 className="text-3xl font-bold whitespace-wrap capitalize;">
          Hello, {username}. Express yourself.
        </h1>

        <div className="text-lg mt-5">
          <h3>
            The internet's source of{" "}
            <span className="underline">whatever you want.</span>
          </h3>
        </div>

        <div>
          <Paper className={classes.paper}>
            <TextField
              multiline
              label="Say what you think"
              className={classes.textField}
              onChange={handleChange}
              value={text}
              inputProps={{ maxLength: 360 }}
            />

            <div className={classes.buttonGroup}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={generateRandomTopic}
              >
                Random Topic
              </Button>

              <div className={classes.buttonGroupRight}>
                <Button
                  variant="outlined"
                  color="default"
                  onClick={() => setText("")}
                >
                  Clear
                </Button>

                <Button
                  variant="outlined"
                  className={classes.button}
                  onClick={handleSubmit}
                  disabled={!text.trim()}
                >
                  Send
                </Button>
              </div>
            </div>
          </Paper>
        </div>
      </section>
    </Grid>
  );
};

export default AddPost;
